//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  defineComponent,
} from "@nuxtjs/composition-api";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";

export default defineComponent({
  name: "TabMenu",
  components: {
    SfButton
  },
  props: {
    tabMenuItems: {
      type: Array,
      default: () => [],
      validator: (value) => {
        return value.every(item =>
          typeof item === 'object' &&
          'button' in item &&
          'ariaLabel' in item &&
          (item.link !== undefined || item.scrollable !== undefined)
        )
      }
    },
  },
  methods: {
    getAccessKeyTitle(index) {
      return `[ALT + ${index}]`
    },

    scrollToElement(elementId) {
      const element = document.getElementById(elementId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
        element.focus()
      }
    }
  }
});
